import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserProfile } from './user.model';
import { Organization, OrganizationConfig } from 'src/app/admin/models/organization.model';

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  updateProfile(data: Partial<UserProfile>) {
    const url = `${environment.apiOrg.url}/organization-user-profile`;

    return this.http.patch<UserProfile>(url, data);
  }

  setCurrentOrganization(organizationId: number) {
    const url = `${environment.apiOrg.url}/organization-user-profile`;
    return this.http.patch<UserProfile>(url, {
      organizationId,
    });
  }

  getOrganizationProfile() {
    const url = `${environment.apiOrg.url}/organization-profile`;

    return this.http.get<Organization>(url);
  }

  getOrganizationConfig() {
    const url = `${environment.apiConfig.url}/organization-configs/readonly`;

    return this.http.get<OrganizationConfig>(url);
  }

  updateOrganizationProfile(data: Partial<Organization>) {
    const url = `${environment.apiOrg.url}/organization-profile`;

    return this.http.patch<Organization>(url, data);
  }
}
